import getGiftCardsApi from '@custom/rtk-apis/hospital/getGiftCards';
import { AppDispatch, RootState } from '@custom/store/store';
import { Icon } from '@ohif/ui';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from "../../../ui/src/contextProviders"

const CheckoutModal = ({ plan, productName, price, onClose, handleSelectPlan }) => {
  const [couponCode, setCouponCode] = useState('');
  const [error, setError] = useState('');
  const [couponStatus, setCouponStatus] = useState('');
  const [discount, setDiscount] = useState(0);
  const modalRef = useRef(null);
  const dispatch = useDispatch<AppDispatch>();
  const [couponList,setCouponList] = useState([])
  const isDarkMode = useTheme();

  const closeHandler = () => {
    onClose();
  };

  const handleSubmit = () => {
    handleSelectPlan(discount, couponCode, couponStatus);
    onClose();
  };


const handleApplyCoupon = () => {
  const trimmed = couponCode.trim()
  const validCoupons = couponList.filter((coupon) => coupon.code == trimmed);
  if (validCoupons && validCoupons?.length > 0) {
    setCouponStatus('valid');
    setDiscount(validCoupons[0]?.points);
    setError('');
  } else {
    setCouponStatus('invalid');
    setDiscount(0);
    setError('Invalid coupon code');
  }
};

useEffect(()=>{
dispatch(getGiftCardsApi()).then((res)=>{
  if(res.payload.success){
    setCouponList(res.payload.giftCards)
  }
})
},[])


  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1rem',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
      }}
    >
      <div
        ref={modalRef}
        className="bg-white w-full max-w-lg rounded-2xl shadow-xl p-6 relative"
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-2xl text-center font-bold text-gray-900">
           Checkout
          </h2>
          <button
            onClick={closeHandler}
            className="text-gray-600 hover:text-red-500 text-2xl"
          >
            &times;
          </button>
        </div>

          {/* Product & Price Info */}
      <div className="mb-6 border border-gray-200 rounded-xl p-4 bg-gray-50 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-800 mb-3">Order Summary</h3>

        <div className={`flex justify-between items-center text-lg mb-2 ${isDarkMode?.isDarkMode ? 'text-white' : 'text-gray-700'}`}>
          <span>Product:</span>
          <span className="font-medium">{productName}</span>
        </div>

        <div className={`flex justify-between items-center text-lg mb-2 ${isDarkMode?.isDarkMode ? 'text-white' : 'text-gray-700'}`}>
          <span>Base Price:</span>
          <span className="font-medium">₹{price}</span>
        </div>

        {discount > 0 && (
          <div className="flex justify-between items-center text-lg text-green-700 mb-2">
            <span>Coupon Discount:</span>
            <span>- ₹{discount}</span>
          </div>
        )}

        <div className="border-t border-dashed border-gray-300 my-3"></div>

        <div className="flex justify-between items-center text-xl font-bold text-teal-700">
          <span>Total</span>
          <span>₹{price - discount}</span>
        </div>
      </div>

      {/* Coupon Input */}
      <div className="mb-6">
        <label className={`block text-sm font-medium mb-1 ${isDarkMode?.isDarkMode ? 'text-white' : 'text-gray-700'}`}>
          Apply Coupon <span className="text-xs">(Optional)</span>
        </label>

        <div className="relative">
          <input
            type="text"
            placeholder="Enter coupon code"
            value={couponCode}
            onChange={(e) => {
              setCouponCode(e.target.value);
              setCouponStatus('');
              setError('');
            }}
            style={{
              border: '1px solid',
              borderColor:
                couponStatus === 'valid'
                  ? '#16a34a'
                  : couponStatus === 'invalid'
                  ? 'red'
                  : '#d1d5db',
              outline: 'none',
            }}
            className="w-full pr-24 px-4 py-2 rounded-full focus:ring-2 focus:ring-teal-500 text-black"
          />

          <button
            onClick={handleApplyCoupon}
            disabled={!couponCode.trim()}
            className={`absolute top-1/2 right-2 -translate-y-1/2 px-4 py-1.5 text-sm rounded-full transition ${(!couponCode.trim() || (!couponCode.trim() && isDarkMode?.isDarkMode)) ? 'bg-teal-600 text-white cursor-not-allowed' : 'bg-teal-600 text-white hover:bg-teal-700'}`}
          >
            Apply
          </button>
        </div>

        {error && <div className="text-red-600 text-sm mt-1">{error}</div>}
        {couponStatus === 'valid' && <div className="text-green-600 text-sm mt-1">Coupon applied successfully!</div>}
      </div>


        {/* Footer */}
        <div className="flex justify-end gap-3">
          <button
            onClick={closeHandler}
            className="px-4 py-2 text-gray-600 hover:text-red-500 rounded-lg transition text-md !border-2 !border-black bg-white shadow"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-5 py-2 bg-teal-600 text-white rounded-lg font-medium hover:bg-teal-700 transition text-md"
          >
            Proceed and Pay
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutModal;
